import { render, staticRenderFns } from "./MemberAddress.vue?vue&type=template&id=69dbfb49"
import script from "./MemberAddress.vue?vue&type=script&lang=js"
export * from "./MemberAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports